import { render, staticRenderFns } from "./stepRealTimeReview.vue?vue&type=template&id=66110fe6&scoped=true"
import script from "./stepRealTimeReview.vue?vue&type=script&lang=js"
export * from "./stepRealTimeReview.vue?vue&type=script&lang=js"
import style0 from "./stepRealTimeReview.vue?vue&type=style&index=0&id=66110fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66110fe6",
  null
  
)

export default component.exports